import { NextPage } from "next";
import Head from "next/head";
import KeyVisual from "components/kaleido/long/KeyVisual";
import Story from "components/kaleido/long/Story";
import Staff from "components/kaleido/long/Staff";
import Record from "components/kaleido/long/Record";
import Merchandise from "components/kaleido/long/Merchandise";
import Announcement from "components/kaleido/long/Announcement";
import InitiativeList from "components/kaleido/long/InitiativeList";
import Distribution from "components/kaleido/long/Distribution";
import AnchorTarget from "components/official/AnchorTarget";
import BackToTop from "components/official/BackToTop";
import SideBackground from "components/kaleido/long/parts/SideBackground";
import { LibraryContextProvider } from "lib/context/kaleido/LibraryContext";
import { useMemo, useEffect } from "react";
import Copyright from "components/kaleido/Copyright";
import styled from "styled-components";

const KaleidoLp: NextPage = () => {
  const baseUrl = process.env.BASE_URL;
  const robotsValue = useMemo(() => {
    return process.env.APP_ENV === "production" ? "all" : "noindex";
  }, []);

  useEffect(() => {
    document.body.style.backgroundColor = "#000";
  }, []);

  return (
    <>
      <Head>
        <link rel="icon" type="image/x-icon" href="/favicon.ico" />
        <title>カレイドスター すごい 公式サイト</title>
        <meta name="description" content="カレイドスターの20周年をきっかけに新たに誕生した公式サイト。今後の施策や、20年の取り組みを公開。" />
        <meta name="keywords" content="カレイドスター,カレイドスター20周年" />
        <meta property="og:title" content="カレイドスター すごい 公式サイト" />
        <meta property="og:description" content="カレイドスターの20周年をきっかけに新たに誕生した公式サイト。今後の施策や、20年の取り組みを公開。" />
        <meta property="og:image" content={`${baseUrl}/image/lp/kaleido/bg/long/key_visual.jpg`} />
        <meta property="og:url" content={`${baseUrl}/lp/kaleido_hp`} />
        <meta property="og:site_name" content="アニメファンド" />
        <meta property="og:locale" content="ja_JP" />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@animefund" />
        <meta property="fb:app_id" content="2809748165906745" />
        <link rel="canonical" href={`${baseUrl}/lp/kaleido_hp`} />
        <meta name="robots" content={robotsValue} />
      </Head>
      <LibraryContextProvider>
        <SideBackground />
        <Background />
        <Root>
          <AnchorTarget id="page_top" />
          <KeyVisual />
          <Story />
          <Staff />
          <Record />
          <Announcement />
          <InitiativeList />
          <Distribution />
          <Merchandise />
          <Copyright />
        </Root>
        <BackToTop />
      </LibraryContextProvider>
    </>
  );
};
export default KaleidoLp;

const Root = styled.div`
  overflow: hidden;
  @media screen and (max-width: 960px) {
    font-size: 14px;
  }
  @media screen and (min-width: 961px) and (max-width: 1280px) {
    font-size: 16px;
  }
  @media screen and (min-width: 1281px) {
    font-size: 18px;
  }

  @media screen and (min-width: 2401px) {
    height: 9500px;
  }
  @media screen and (min-width: 2501px) {
    height: 9550px;
  }
  @media screen and (min-width: 2601px) {
    height: 9650px;
  }
  @media screen and (min-width: 2701px) {
    height: 9700px;
  }
  @media screen and (min-width: 2801px) {
    height: 9800px;
  }
  @media screen and (min-width: 2901px) {
    height: 9900px;
  }
  @media screen and (min-width: 3001px) {
    height: 10000px;
  }
  @media screen and (min-width: 3101px) {
    height: 10150px;
  }
  @media screen and (min-width: 3201px) {
    height: 10200px;
  }
  @media screen and (min-width: 3301px) {
    height: 10300px;
  }
  @media screen and (min-width: 3401px) {
    height: 10400px;
  }
  @media screen and (min-width: 3501px) {
    height: 10500px;
  }
  @media screen and (min-width: 3601px) {
    height: 10600px;
  }
  @media screen and (min-width: 3701px) {
    height: 10700px;
  }
  @media screen and (min-width: 3801px) {
    height: 10800px;
  }
  @media screen and (min-width: 3901px) {
    height: 10900px;
  }
  @media screen and (min-width: 4001px) {
    height: 11000px;
  }
  @media screen and (min-width: 4201px) {
    height: 11200px;
  }
  @media screen and (min-width: 4401px) {
    height: 11400px;
  }
  @media screen and (min-width: 4601px) {
    height: 11500px;
  }
  @media screen and (min-width: 4801px) {
    height: 11700px;
  }
  @media screen and (min-width: 5001px) {
    height: 11800px;
  }
`;
const Background = styled.div`
  position: absolute;
  width: 100%;
  min-height: 100%;
  overflow: hidden;
  z-index: -2;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: rgb(255, 255, 255);
`;
